import api from "./api";

export const CLOCK_GET_REQUEST = 'clock/CLOCK_GET/REQUEST';
export const CLOCK_GET_SUCCESS = 'clock/CLOCK_GET/SUCCESS';
export const CLOCK_GET_FAILURE = 'clock/CLOCK_GET/FAILURE';
export const CLOCK_GET_EMPLOYEES_REQUEST = "clock/CLOCK_GET_EMPLOYEES/REQUEST";
export const CLOCK_GET_EMPLOYEES_SUCCESS = "clock/CLOCK_GET_EMPLOYEES/SUCCESS";
export const CLOCK_GET_EMPLOYEES_FAILURE = "clock/CLOCK_GET_EMPLOYEES/FAILURE";
export const CLOCK_GET_EVENTS_REQUEST = "clock/CLOCK_GET_EVENTS/REQUEST";
export const CLOCK_GET_EVENTS_SUCCESS = "clock/CLOCK_GET_EVENTS/SUCCESS";
export const CLOCK_GET_EVENTS_FAILURE = "clock/CLOCK_GET_EVENTS/FAILURE";
export const CLOCK_SAVE_EVENTS_REQUEST = "clock/CLOCK_SAVE_EVENTS/REQUEST";
export const CLOCK_SAVE_EVENTS_SUCCESS = "clock/CLOCK_SAVE_EVENTS/SUCCESS";
export const CLOCK_SAVE_EVENTS_FAILURE = "clock/CLOCK_SAVE_EVENTS/FAILURE";
export const CLOCK_LOAD_REQUEST = 'clock/CLOCK_LOAD/REQUEST';
export const CLOCK_LOAD_SUCCESS = 'clock/CLOCK_LOAD/SUCCESS';
export const CLOCK_LOAD_FAILURE = 'clock/CLOCK_LOAD/FAILURE';
export const CLOCK_SAVE_REQUEST = 'clock/CLOCK_SAVE/REQUEST';
export const CLOCK_SAVE_SUCCESS = 'clock/CLOCK_SAVE/SUCCESS';
export const CLOCK_SAVE_FAILURE = 'clock/CLOCK_SAVE/FAILURE';
export const CLOCK_IN_REQUEST = 'clock/CLOCK_IN/REQUEST';
export const CLOCK_IN_SUCCESS = 'clock/CLOCK_IN/SUCCESS';
export const CLOCK_IN_FAILURE = 'clock/CLOCK_IN/FAILURE';
export const CLOCK_OUT_REQUEST = 'clock/CLOCK_OUT/REQUEST';
export const CLOCK_OUT_SUCCESS = 'clock/CLOCK_OUT/SUCCESS';
export const CLOCK_OUT_FAILURE = 'clock/CLOCK_OUT/FAILURE';

// Admin
export const CLOCK_ADMIN_NEW_CLOCK_REQUEST = 'clock/CLOCK_ADMIN_NEW_CLOCK/REQUEST';
export const CLOCK_ADMIN_NEW_CLOCK_SUCCESS = 'clock/CLOCK_ADMIN_NEW_CLOCK/SUCCESS';
export const CLOCK_ADMIN_NEW_CLOCK_FAILURE = 'clock/CLOCK_ADMIN_NEW_CLOCK/FAILURE';
export const CLOCK_ADMIN_CLOCKS_REQUEST = 'clock/CLOCK_ADMIN_CLOCKS/REQUEST';
export const CLOCK_ADMIN_CLOCKS_SUCCESS = 'clock/CLOCK_ADMIN_CLOCKS/SUCCESS';
export const CLOCK_ADMIN_CLOCKS_FAILURE = 'clock/CLOCK_ADMIN_CLOCKS/FAILURE';
export const CLOCK_ADMIN_SET_WAREHOUSE = 'clock/CLOCK_ADMIN_SET_WAREHOUSE';
export const CLOCK_ADMIN_SET_EMPLOYEE = 'clock/CLOCK_ADMIN_SET_EMPLOYEE';
export const CLOCK_ADMIN_SET_ACTIVITY = 'clock/CLOCK_ADMIN_SET_ACTIVITY';
export const CLOCK_ADMIN_SET_DATE_RANGE = 'clock/CLOCK_ADMIN_SET_DATE_RANGE';

export function adminSetWarehouse(warehouse_id){
    return {
        type: CLOCK_ADMIN_SET_WAREHOUSE,
        warehouse_id,
    }
}
export function adminSetEmployee(employee_id){
    return {
        type: CLOCK_ADMIN_SET_EMPLOYEE,
        employee_id,
    }
}

export function adminSetActivity(activity_id){
    return {
        type: CLOCK_ADMIN_SET_ACTIVITY,
        activity_id,
    }
}

export function adminSetDateRange(start, end){
    return {
        type: CLOCK_ADMIN_SET_DATE_RANGE,
        start,
        end,
    }
}

export function get() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.get()
                .then(
                    clock => {
                        dispatch(success(clock));
                        resolve();
                    },
                    error => {
                        handleErrorCode(error,dispatch);
                        dispatch(failure(error));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return {type: CLOCK_GET_REQUEST}
    }

    function success(clock) {
        return {type: CLOCK_GET_SUCCESS, clock}
    }

    function failure(error) {
        return {type: CLOCK_GET_FAILURE, error}
    }
}

export function getEmployees() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.getEmployees()
                .then(
                    employees => {
                        dispatch(success(employees));
                        resolve(employees);
                    },
                    error => {
                        handleErrorCode(error, dispatch);
                        dispatch(failure(error));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return { type: CLOCK_GET_EMPLOYEES_REQUEST };
    }

    function success(employees) {
        return {
            type: CLOCK_GET_EMPLOYEES_SUCCESS,
            employees
        };
    }

    function failure(error) {
        return {
            type: CLOCK_GET_EMPLOYEES_FAILURE,
            error
        };
    }
}

export function getEvents(warehouse_id, start, end) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.getEvents(warehouse_id, start, end)
                .then(
                    events => {
                        dispatch(success(events));
                        resolve(events);
                    },
                    error => {
                        handleErrorCode(error, dispatch);
                        dispatch(failure(error));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return { type: CLOCK_GET_EVENTS_REQUEST };
    }

    function success(events) {
        return {
            type: CLOCK_GET_EVENTS_SUCCESS,
            events
        };
    }

    function failure(error) {
        return {
            type: CLOCK_GET_EVENTS_FAILURE,
            error
        };
    }
}

export function saveEvents(warehouse_id, events) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.saveEvents(warehouse_id, events)
                .then(
                    _ => {
                        dispatch(success());
                        resolve();
                    },
                    error => {
                        handleErrorCode(error, dispatch);
                        dispatch(failure(error));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return { type: CLOCK_GET_EVENTS_REQUEST };
    }

    function success() {
        return { type: CLOCK_GET_EVENTS_SUCCESS };
    }

    function failure(error) {
        return {
            type: CLOCK_GET_EVENTS_FAILURE,
            error
        };
    }
}


export function load(id) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.load(id)
                .then(
                    clock => {
                        dispatch(success(clock));
                        resolve();
                    },
                    error => {
                        handleErrorCode(error,dispatch);
                        dispatch(failure(error));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return {type: CLOCK_LOAD_REQUEST}
    }

    function success(clock) {
        return {type: CLOCK_LOAD_SUCCESS, clock}
    }

    function failure(error) {
        return {type: CLOCK_LOAD_FAILURE, error}
    }
}


export function save(id,clock) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.save(id,clock)
                .then(
                    clock => {
                        dispatch(success(clock));
                        resolve();
                    },
                    error => {
                        handleErrorCode(error,dispatch);
                        dispatch(failure(error));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return {type: CLOCK_SAVE_REQUEST}
    }

    function success(clock) {
        return {type: CLOCK_SAVE_SUCCESS, clock}
    }

    function failure(error) {
        return {type: CLOCK_SAVE_FAILURE, error}
    }
}

export function newClock(clock) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.newClock(clock)
                .then(
                    clock => {
                        dispatch(success(clock));
                        resolve(clock);
                    },
                    error => {
                        handleErrorCode(error,dispatch);
                        dispatch(failure(error));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return {type: CLOCK_ADMIN_NEW_CLOCK_REQUEST}
    }

    function success(clock) {
        return {type: CLOCK_ADMIN_NEW_CLOCK_SUCCESS, clock}
    }

    function failure(error) {
        return {type: CLOCK_ADMIN_NEW_CLOCK_FAILURE, error}
    }
}



export function clockIn(body) {

    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.clockIn(body)
                .then(
                    clock => {
                        dispatch(success(clock));
                    },
                    error => {
                        handleErrorCode(error,dispatch);
                        dispatch(failure(error));
                    }
                );
        });
    };

    function request() {
        return {type: CLOCK_IN_REQUEST}
    }

    function success(clock) {
        return {type: CLOCK_IN_SUCCESS, clock}
    }

    function failure(error) {
        return {type: CLOCK_IN_FAILURE, error}
    }
}

export function clockOut() {

    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());

            api.clockOut()
                .then(
                    clock => {
                        dispatch(success(clock));
                        resolve()
                    },
                    error => {
                        handleErrorCode(error,dispatch);
                        dispatch(failure(error));
                        resolve()
                    }
                );
        });

    };

    function request() {
        return {type: CLOCK_OUT_REQUEST}
    }

    function success(clock) {
        return {type: CLOCK_OUT_SUCCESS, clock}
    }

    function failure(error) {
        return {type: CLOCK_OUT_FAILURE, error}
    }
}


export function loadAdminClocks(start,end){

    return dispatch => {
        dispatch(request());

        api.loadAdminClocks(start,end)
            .then(
                clocks => {
                    dispatch(success(clocks));
                },
                error => {
                    handleErrorCode(error,dispatch);
                    dispatch(failure(error));
                }
            );
    };

    function request() {
        return {type: CLOCK_ADMIN_CLOCKS_REQUEST}
    }

    function success(clocks) {
        return {type: CLOCK_ADMIN_CLOCKS_SUCCESS, clocks}
    }

    function failure(error) {
        return {type: CLOCK_ADMIN_CLOCKS_FAILURE, error}
    }
}


function handleErrorCode(error, dispatch) {
    if(error === 401){
        //dispatch(logout());
    }
}


export default {
    CLOCK_GET_REQUEST,
    CLOCK_GET_SUCCESS,
    CLOCK_GET_FAILURE,
    CLOCK_GET_EMPLOYEES_REQUEST,
    CLOCK_GET_EMPLOYEES_SUCCESS,
    CLOCK_GET_EMPLOYEES_FAILURE,
    CLOCK_GET_EVENTS_REQUEST,
    CLOCK_GET_EVENTS_SUCCESS,
    CLOCK_GET_EVENTS_FAILURE,
    CLOCK_SAVE_EVENTS_REQUEST,
    CLOCK_SAVE_EVENTS_SUCCESS,
    CLOCK_SAVE_EVENTS_FAILURE,
    CLOCK_LOAD_REQUEST,
    CLOCK_LOAD_SUCCESS,
    CLOCK_LOAD_FAILURE,
    CLOCK_SAVE_REQUEST,
    CLOCK_SAVE_SUCCESS,
    CLOCK_SAVE_FAILURE,
    CLOCK_IN_REQUEST,
    CLOCK_IN_SUCCESS,
    CLOCK_IN_FAILURE,
    CLOCK_OUT_REQUEST,
    CLOCK_OUT_SUCCESS,
    CLOCK_OUT_FAILURE,
    CLOCK_ADMIN_CLOCKS_REQUEST,
    CLOCK_ADMIN_CLOCKS_SUCCESS,
    CLOCK_ADMIN_CLOCKS_FAILURE,
    CLOCK_ADMIN_SET_WAREHOUSE,
    CLOCK_ADMIN_SET_EMPLOYEE,
    CLOCK_ADMIN_SET_ACTIVITY,
    CLOCK_ADMIN_SET_DATE_RANGE,
    CLOCK_ADMIN_NEW_CLOCK_FAILURE,
    CLOCK_ADMIN_NEW_CLOCK_SUCCESS,
    CLOCK_ADMIN_NEW_CLOCK_REQUEST,
};



// WEBPACK FOOTER //
// ./src/scenes/Clock/reducer/actions.js